'use strict';

module.exports = ['authorization', 'proxy-authorization', 'cookie', 'set-cookie', 'x-api-key', 'password'];



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/helpers/defaultRedactKeys.js
// module id = 336
// module chunks = 0